import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'hideSideBarClick',
  'lockSideBarClick',
  'scheduleCallCSClick',
  'settingsAndMembersClick',
  'viewPlansSidebarClick',
] as const;

export const sidebarEvents = getMappedEvents([...EVENTS]);
